var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-info noShorex"},[_c('div',{staticClass:"product-title"},[_vm._v("关于海外航线“预付费类”船上产品或服务的重要说明：")]),_c('div',{staticClass:"product-shorex-tips"},[_c('div',{staticClass:"shorex-tips-left"}),_c('p',[_vm._v("由于技术限制，皇家加勒比国际游轮旗下海外出发航线的船上付费项目暂时无法在皇家行前订官网以及国际官网提前预订和支付（船上付费类项目通常包括：海外目的地的岸上观光，船上各类付费餐饮、娱乐等），请您于登船后进行预订。")])])])
}]

export { render, staticRenderFns }